// All'avvio disiscrive il vecchio service worker `/sw.js` (eliminato il 03/11/2026) se il browser lo ha ancora registrato: altrimenti a ogni
// controllo di aggiornamento riceve l'HTML dell'app e scrive in console «unsupported MIME type 'text/html'». Non lancia mai.
import { rimuoviServiceWorkerObsoleti } from "~/utils/serviceWorkerObsoleti";

export default defineNuxtPlugin(() => {
  if (!("serviceWorker" in navigator)) return;
  void rimuoviServiceWorkerObsoleti().catch(() => {});
});
